import React, { ReactNode } from 'react';
import { StyleSheet, View, ViewStyle, StyleProp } from 'react-native';
import { useMediaQuery } from 'react-responsive';
type Props = {
  style?: StyleProp<ViewStyle>;
  children?: ReactNode;
};

const Panel = (props: Props) => {
  const { children, style } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <View style={[styles.panel, isBigScreen && styles.panelBigScreen, style]}>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  panel: {
    backgroundColor: '#F6F8FA',
    shadowColor: '#00000040',
    shadowOpacity: 1,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 4 },
    borderRadius: 0,
    marginTop: 0,
    paddingTop: 0,
    width: '100%',
    overflow: 'hidden',
  },
  panelBigScreen: {
    borderRadius: 16,
    marginTop: 16,
    width: '100%',
    overflow: 'visible',
  },
});

export default Panel;
